import {
  Backdrop,
  CircularProgress,
  Stack,
  Typography,
  alpha,
  useTheme,
} from "@mui/material";

import { marketplaceTypography as mt } from "../constants/marketplaceTypography";

interface CheckoutPaymentOverlayProps {
  open: boolean;
  orderId?: number | null;
  /** true enquanto cria o pedido, antes de abrir a janela de pagamento */
  preparing?: boolean;
}

/** Tela escura + loading enquanto aguarda confirmação do pagamento. */
export function CheckoutPaymentOverlay({
  open,
  orderId,
  preparing = false,
}: CheckoutPaymentOverlayProps) {
  const theme = useTheme();

  const title = preparing ? "Preparando pagamento" : "Aguardando pagamento";
  const subtitle = preparing
    ? "Estamos criando seu pedido. A janela de pagamento abrirá em instantes."
    : "Conclua o pagamento na janela que abriu. Verificamos o status automaticamente a cada poucos segundos.";

  return (
    <Backdrop
      open={open}
      sx={{
        zIndex: theme.zIndex.modal + 20,
        flexDirection: "column",
        gap: 2,
        bgcolor: alpha(theme.palette.common.black, 0.72),
      }}
    >
      <CircularProgress size={52} thickness={4} sx={{ color: "common.white" }} />
      <Stack spacing={0.75} alignItems="center" sx={{ px: 3, maxWidth: 360 }}>
        <Typography
          sx={{
            ...mt.sectionTitle,
            color: "common.white",
            textAlign: "center",
          }}
        >
          {title}
        </Typography>
        {orderId && !preparing ? (
          <Typography
            sx={{ ...mt.bodySecondary, color: alpha("#fff", 0.85), textAlign: "center" }}
          >
            Pedido #{orderId}
          </Typography>
        ) : null}
        <Typography
          sx={{ ...mt.bodySecondary, color: alpha("#fff", 0.75), textAlign: "center" }}
        >
          {subtitle}
        </Typography>
      </Stack>
    </Backdrop>
  );
}
